import React, { useEffect, useState } from 'react';
import {
  useSetRecoilState,
  useRecoilValueLoadable,
  useRecoilValue,
} from 'recoil';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as _ from 'lodash';
import md5 from 'md5';

import { methodNameEnum } from '../../recoil/selectors/makePHPRequest';
import { callReportingData } from '../../recoil/selectors/callReportingData';
import { forceCallReportUpdate } from '../../recoil/atoms/forceCallReportUpdate';
import { user } from '../../recoil/atoms/user';
import { getFirestoreUsers } from '../../common/firebase';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { KIXIE_COLORS } from '../../constants';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    background: '#000000',
    color: '#FFFFFF',
  },
  containerGrid: {
    padding: '30px 15px',
  },
  gridItem: {
    marginBottom: 15,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
  },
  avatarContainer: {
    background: '#0098C7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginBottom: 15,
  },
  avatar: {
    height: 155,
    width: 155,
    borderRadius: '50%',
  },
  stats: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  center: {
    textAlign: 'center',
  },
}));

const pad = (num) => {
  return ('0' + num).slice(-2);
};

const hhmmss = (secs) => {
  let minutes = Math.floor(secs / 60);
  secs = secs % 60;
  const hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return `${hours}:${pad(minutes)}:${pad(secs)}`;
};

let newUsersData = [];
let globalUsers = [];

export function Leaderboard() {
  const classes = useStyles();
  const [firestoreUser, setFirestoreUser] = useState([]);
  const forceUpdate = useSetRecoilState(forceCallReportUpdate);
  const storageUser = useRecoilValue(user);
  const data = {
    call: methodNameEnum.GET_BUSINESS_DATA,
  };
  const businessData = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify(data),
    })
  );
  const callData = {
    call: methodNameEnum.GET_BUSINESS_USERS,
  };

  const users = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_USERS,
      payloadJsonString: JSON.stringify(callData),
    })
  );
  const report = useRecoilValueLoadable(callReportingData(false));

  const BusinessData = Object.assign(
    {},
    businessData?.contents?.response?.data?.result?.[0] || {}
  );
  const BusinessUsers = users?.contents?.response?.data?.result || [];
  const CallReport = Object.assign(
    {},
    report?.contents?.data?.stats?.users || {}
  );

  //console.log('users', users);
  //console.log('BusinessUsers', BusinessUsers);
  //console.log('CallReport', CallReport);

  const updateFirestoreUsers = (updated) => {
    if (globalUsers.length === 0) {
      setFirestoreUser(updated);
    } else {
      const fUsers = [...globalUsers];
      updated.forEach((usr) => {
        const index = fUsers.findIndex((fusr) => usr.u === fusr.u);
        if (index > -1) {
          fUsers[index] = usr;
        }
      });
      setFirestoreUser(fUsers);
    }
  };

  useEffect(() => {
    getFirestoreUsers(storageUser, updateFirestoreUsers);
  }, [storageUser]);

  //console.log('firestoreUser', firestoreUser);
  //console.log('globalUsers', globalUsers);
  //console.log('storageUser', storageUser);

  useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate((n) => n + 1);
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const setValues = () => {
    if (Object.keys(CallReport).length > 0 && firestoreUser.length > 0) {
      const sortby = BusinessData.leaderboardSort;
      const ActiveUsers = BusinessUsers.filter((u) => u.isactive === 1) || [];
      const stats = {};
      const usersData = [];

      ActiveUsers.forEach((user) => {
        const e = { ...CallReport[user.userid] };
        e.userEmail = user.email;
        e.emailName = user.email.split('@')[0];
        e.fname = user.fname;
        e.lname = user.lname;
        if (CallReport[user.userid]) {
          stats.allcalls = e.total || 0;
          stats.allconnections = e.allconnections || 0;
          stats.allavgduration = e.alldurationavg || 0;
          stats.alldurationavg = e.alldurationavg || 0;
          stats.alldurationavg2 = e.alldurationavg2 || 0;
          stats.avgduration = hhmmss(Math.ceil(stats.alldurationavg2));

          const tduration = stats.allavgduration * stats.allcalls;
          const tdurationread = hhmmss(Math.ceil(tduration));

          stats.tdurationread = tdurationread;
          stats.tduration = tduration;
          usersData.push({
            ...e,
            ...stats,
          });
        }
      });

      newUsersData = _.sortBy(usersData, sortby).reverse();
      newUsersData.forEach((obj, i) => {
        const stat = [];
        const fUser = firestoreUser.find(
          (f) => parseInt(f.u.split('-u-')[1]) === obj.userid
        );
        if (fUser) {
          if (fUser.loggedin === 0) {
            newUsersData[i].status = 'Logged Out';
          } else {
            if (fUser.DND === 1) {
              newUsersData[i].status = 'Do Not Disturb';
            } else {
              if (fUser.oncall === 1) {
                newUsersData[i].status = 'On Call';
              } else {
                newUsersData[i].status = 'Available';
              }
            }
          }
        }
        switch (sortby) {
          case 'allconnections':
            stat.push({
              title: 'Connections',
              value: obj.allconnections,
            });
            stat.push({
              title: 'Calls',
              value: obj.allcalls,
            });
            stat.push({
              title: 'Duration',
              value: obj.tdurationread,
            });
            break;
          case 'allcalls':
            stat.push({
              title: 'Calls',
              value: obj.allcalls,
            });
            stat.push({
              title: 'Connections',
              value: obj.allconnections,
            });
            stat.push({
              title: 'Duration',
              value: obj.tdurationread,
            });
            break;
          default:
            stat.push({
              title: 'Connections',
              value: obj.allconnections,
            });
            stat.push({
              title: 'Duration',
              value: obj.tdurationread,
            });
            stat.push({
              title: 'Calls',
              value: obj.allcalls,
            });
            break;
        }
        newUsersData[i].data = stat;
      });

      return newUsersData;
    }

    globalUsers = firestoreUser;
    return newUsersData;
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4} className={classes.containerGrid}>
        {setValues().map((stat) => (
          <Grid
            item
            sm={6}
            md={3}
            key={`stat-${stat.userid}`}
            className={classes.gridItem}
          >
            <div className={classes.item}>
              <span
                style={{
                  background:
                    stat.status === 'Do Not Disturb'
                      ? KIXIE_COLORS.dnd
                      : stat.status === 'On Call'
                      ? KIXIE_COLORS.onCall
                      : stat.status === 'Logged Out'
                      ? KIXIE_COLORS.loggedOut
                      : KIXIE_COLORS.available,
                }}
                className={classes.avatarContainer}
              >
                <img
                  src={
                    stat.fname && stat.lname
                      ? `https://www.gravatar.com/avatar/${md5(
                          stat.userEmail
                        )}?s=175&d=https%3A%2F%2Fui-avatars.com%2Fapi%2F${
                          stat.fname
                        }%2B${
                          stat.lname
                        }%2F128%2FFFA6AA%2F000000%2F2%2F0.5%2Ffalse%2Ftrue%2Ftrue`
                      : `https://www.gravatar.com/avatar/${md5(
                          stat.userEmail
                        )}?s=175&d=identicon`
                  }
                  className={classes.avatar}
                />
                <Typography variant="h1">{stat.data[0].value}</Typography>
              </span>
              <span className={classes.stats}>
                <Typography variant="h3" gutterBottom>
                  {stat.data[1].title}
                </Typography>
                <Typography variant="h3" gutterBottom>
                  {stat.data[1].value}
                </Typography>
              </span>
              <span className={classes.stats}>
                <Typography variant="h3" gutterBottom>
                  {stat.data[2].title}
                </Typography>
                <Typography variant="h3" gutterBottom>
                  {stat.data[2].value}
                </Typography>
              </span>
              <Typography variant="h3" gutterBottom className={classes.center}>
                {stat.fname} {stat.lname}
              </Typography>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
